import { render, staticRenderFns } from "./slider-widget.vue?vue&type=template&id=0ceeec3e&scoped=true&"
import script from "./slider-widget.vue?vue&type=script&lang=js&"
export * from "./slider-widget.vue?vue&type=script&lang=js&"
import style0 from "./slider-widget.vue?vue&type=style&index=0&id=0ceeec3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceeec3e",
  null
  
)

export default component.exports